"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
exports.__esModule = true;
exports.estimateMaxSpendable = void 0;
var bignumber_js_1 = require("bignumber.js");
var account_1 = require("../../account");
var logic_1 = require("./logic");
var js_prepareTransaction_1 = require("./js-prepareTransaction");
var cryptoassets_1 = require("@ledgerhq/cryptoassets");
var js_getFeesForTransaction_1 = require("./js-getFeesForTransaction");
var estimateMaxSpendable = function (_a) {
    var account = _a.account, parentAccount = _a.parentAccount, transaction = _a.transaction;
    return __awaiter(void 0, void 0, void 0, function () {
        var mainAccount, algorandResources, tx, tokenAccount, fees, maxSpendable;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    mainAccount = (0, account_1.getMainAccount)(account, parentAccount);
                    algorandResources = mainAccount.algorandResources;
                    if (!algorandResources) {
                        throw new Error("Algorand account expected");
                    }
                    tx = __assign(__assign(__assign(__assign({}, (0, js_prepareTransaction_1.createTransaction)()), { subAccountId: account.type === "Account" ? null : account.id }), transaction), { recipient: (transaction === null || transaction === void 0 ? void 0 : transaction.recipient) || (0, cryptoassets_1.getAbandonSeedAddress)(mainAccount.currency.id), useAllAmount: true });
                    tokenAccount = tx.subAccountId &&
                        mainAccount.subAccounts &&
                        mainAccount.subAccounts.find(function (ta) { return ta.id === tx.subAccountId; });
                    if (!tokenAccount) return [3 /*break*/, 1];
                    return [2 /*return*/, tokenAccount.balance];
                case 1: return [4 /*yield*/, (0, js_getFeesForTransaction_1.getEstimatedFees)(mainAccount, tx)];
                case 2:
                    fees = _b.sent();
                    maxSpendable = (0, logic_1.computeAlgoMaxSpendable)({
                        accountBalance: mainAccount.balance,
                        nbAccountAssets: algorandResources.nbAssets,
                        mode: tx.mode
                    });
                    maxSpendable = maxSpendable.minus(fees);
                    return [2 /*return*/, maxSpendable.gte(0) ? maxSpendable : new bignumber_js_1.BigNumber(0)];
            }
        });
    });
};
exports.estimateMaxSpendable = estimateMaxSpendable;
//# sourceMappingURL=js-estimateMaxSpendable.js.map